import React from 'react';
import Image from 'next/image';
import { StyledPlatofrmHero } from './howToInstallHero.styles';
import { IPlatform, IPlugin } from '../../types';
import { WidgetNavbar } from '../widgetNavbar/widgetNavbar.comp';

interface IHowToInstallHeroProps {
    platform: IPlatform;
    app: IPlugin;
}

export const HowToInstallHero = ({ platform, app }: IHowToInstallHeroProps) => {
    return (
        <StyledPlatofrmHero>
            <WidgetNavbar
                widget={app}
                platform={platform}
            />
            <div className="hero-wrapper">
                <h1>How to add {app.name} to a {platform.title} {platform.siteSynonym}</h1>
                <h2>Embed {app.name} on {platform.title} in just a few steps</h2>
            </div>
        </StyledPlatofrmHero>
    );
};
